import { ChangeEvent } from 'react'
import styles from '../../AdminTools.module.css'

interface HeaderAlignedMessageTypeProps {
  value: number
  onChange: (value: number) => void
  disabled?: boolean
}

export const HeaderAlignedMessageType = ({
  value,
  onChange,
  disabled,
}: HeaderAlignedMessageTypeProps) => {
  const typeOptions: { [key: number]: string } = {
    0: 'Info',
    1: 'Varning',
    2: 'Kritisk',
  }

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    onChange(Number(e.target.value))
  }

  return (
    <div className={styles.headerAlignedRow}>
      <div className={styles.headerAlignedLabel}>Typ</div>
      <select
        value={value.toString()}
        onChange={handleChange}
        disabled={disabled}
        className={styles.textInput}
        style={{ minWidth: '150px' }}
      >
        {Object.entries(typeOptions).map(([key, value]) => (
          <option key={key} value={key}>
            {value}
          </option>
        ))}
      </select>
    </div>
  )
}
